import { formatFirstUpperCase } from './format';

// Backend categories (Category = {id, name, weight}) carry no i18n field.
// Localize via a small frontend dictionary in the 'home' namespace, keyed by a
// slug of the name (e.g. "World Cup" -> "category-world-cup"). Any category
// the dictionary doesn't know about — new or renamed on the backend — falls
// back to today's rendering (Capitalized name) via i18next's defaultValue,
// never a raw translation-key string.
export const categorySlug = (name: string): string =>
  `category-${name.trim().toLowerCase().replace(/\s+/g, '-')}`;

// `t` is typed loosely (rather than react-i18next's TFunction) so any call
// site's `t` — regardless of which namespaces its own useTranslation() hook
// requested — can be passed in directly. Callers must include 'home' in their
// useTranslation() namespace list so the dictionary is loaded/subscribed;
// this helper only supplies the explicit `ns: 'home'` lookup + fallback.
export const categoryLabel = (
  t: (key: string, options?: { ns?: string; defaultValue?: string }) => string,
  name: string
): string => t(categorySlug(name), { ns: 'home', defaultValue: formatFirstUpperCase(name) });
